import { configureRequest } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetLockerMetricsErrorResponse,
  GetLockerMetricsRequest,
  GetLockerMetricsSuccessResponse
} from './getLockerMetrics.types'

export const getLockerMetricsApi = async (
  request: GetLockerMetricsRequest
): Promise<GetLockerMetricsSuccessResponse> => {
  const response = await configureRequest({
    url: urls.admin.getLockerMetrics,
    method: 'GET',
    params: Object.keys(request).length > 0 ? (request as Record<string, string | number | string[]>) : undefined,
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetLockerMetricsSuccessResponse
  } else {
    throw response as GetLockerMetricsErrorResponse
  }
}

export default getLockerMetricsApi
